module.exports = "/_next/static/images/Hero@3x-de7953509475051a155fcd23936f934a.webp";